import { z } from 'zod';
import { IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const NotificationChannelSchema = z.enum(['in_app', 'email']);
export const NotificationStatusSchema = z.enum(['pending', 'sent', 'failed']);
export const NotificationSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    recipientMembershipId: IdSchema,
    channel: NotificationChannelSchema,
    type: z.string(),
    title: z.string(),
    body: z.string(),
    actionUrl: z.string().nullable(),
    status: NotificationStatusSchema,
    readAt: TimestampSchema.nullable(),
    sentAt: TimestampSchema.nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateNotificationRequestSchema = z.strictObject({
    recipientMembershipId: IdSchema,
    channel: NotificationChannelSchema.default('in_app'),
    type: z.string().trim().min(1).max(100),
    title: z.string().trim().min(1).max(200),
    body: z.string().trim().min(1).max(5000),
    actionUrl: z.string().trim().max(1000).nullable().default(null),
});
export const NotificationListSchema = z.strictObject({
    items: z.array(NotificationSchema),
    page: PageInfoSchema,
});
